import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import * as qs from 'query-string';
const autobind = require('react-autobind');

import {
  CircularProgress
} from '@material-ui/core';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import { API, Range, Server, Sort, Direction, SortOptions } from './api';
import { ItemChart } from './item-chart';
import { ItemData } from './item-data';

import styles from './app.module.scss';

const theme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      main: '#263238'
    },
    secondary: {
      main: '#ff5722'
    }
  },
  typography: {
    useNextVariants: true,
  },
});

interface AppState {
  itemName: string;
  sortOptions: SortOptions;
  loading: boolean;
}

@observer
class App extends React.Component<any, AppState> {

  @observable items: ItemData[] = [];
  private page: number = 1;
  private chartOptions = {
    range: Range.Week,
    server: Server.Both
  };

  constructor(props: any) {
    super(props);

    autobind(this);
    this.state = {
      itemName: "",
      sortOptions: {
        range: Range.Week,
        server: Server.Both,
        sort: Sort.Change,
        direction: Direction.Desc
      },
      loading: false
    };
  }

  componentWillMount() {
    const location = this.props.location;
    let queryName = "";
    if (location && location.search) {
      const queryParams = qs.parse(location.search);
      queryName = queryParams["q"] as string || "";
      this.setState({ itemName: queryName });
    }

    this.getData(queryName, this.state.sortOptions);
  }

  componentDidMount() {
    //
  }

  componentWillUnmount() {
    //
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <div className={styles["progress"]} hidden={!this.state.loading}>
          <CircularProgress color="secondary" />
        </div>
        <div id="app" className={styles["app"]}>{this.renderItemCharts()}</div>
      </MuiThemeProvider>
    );
  }

  private renderItemCharts(): JSX.Element[] {
    if(this.items.length > 0) {
      const item = this.items[0];
      return [
        <ItemChart key="0" data={item} range={this.chartOptions.range} server={this.chartOptions.server} />
      ];
    }
    return [];
  }

  private getData(item: string, sort: SortOptions) {
    this.setState({ loading: true });

    this.page = 1;
    API.getData({ item, sort, page: this.page }, (items) => {
      this.setState({ loading: false });
      this.items = []; // Need to first clear out array due to bug in chart.js, crashes in some cases
      this.chartOptions = {
        range: this.state.sortOptions.range,
        server: this.state.sortOptions.server
      };
      this.items = items;
      this.getOnDeckData(item, sort);
    });
  }

  private getOnDeckData(item: string, sort: SortOptions) {
    this.page++;
  }

}

export default App;
